import Fetch from "./requestHttp";
class Request extends Fetch {
  constructor(config) {
    super(config);
  }
  cashierMsg(data) {
    return this.request({
      url: "/pay/cashier/getMessage",
      method: "POST",
      data: data
    });
  }
  // 收银台下单页面
  payforType(data) {
    return this.request({
      url: "/pay/cashier/unifiedOrder",
      method: "POST",
      data: data
    });
  }
  // 收银台下单页面
  payforType2(data) {
    return this.request({
      url: "/pay/order/unifiedOrder",
      method: "POST",
      data: data
    });
  }
  // 聚合码查询配置信息
  payGetMessage(data) {
    return this.request({
      url: "/pay/cashier/scan/getMessage",
      method: "POST",
      data: data
    });
  }
  // 聚合码下单支付
  payunifiedOrder(data) {
    return this.request({
      url: "/pay/cashier/scan/unifiedOrder",
      method: "POST",
      data: data
    });
  }

  // 获取openid
  getOpenid(data) {
    return this.request({
      url: "/pay/access/getOpenId",
      method: "POST",
      data: data
    });
  }
  //查询微信appid
  getAppid(data) {
    return this.request({
      url: "/pay/access/getAppId",
      method: "POST",
      data: data
    });
  }
  // 获取订单金额
  getAmount(data) {
    return this.request({
      url: "/pm/order/amount/device",
      method: "POST",
      data: data
    });
  }
  // 获取订单列表
  getList(data) {
    return this.request({
      url: "/pm/order/list/device",
      method: "POST",
      data: data
    });
  }
  //提现
  merchantTransfer(data) {
    return this.request({
      url: "/pay/merchantTransfer/unifiedOrder",
      method: "POST",
      data
    });
  }
  //查询提现订单状态
  queryTransferOrderStatus(data) {
    return this.request({
      url: "/pay/merchantTransfer/queryTransferOrderStatus",
      method: "POST",
      data
    });
  }
  //发起免确认收款权限
  wechatConfirmAuth(data) {
    return this.request({
      url: "/pay/merchantTransfer/wechatConfirmAuth",
      method: "POST",
      data
    });
  }
}
export default new Request();



// WEBPACK FOOTER //
// ./src/api/cashier.js